import once from 'lodash/once';
import { createContext } from 'react';
/** The favorite item layout context. */
export const getFavoriteItemLayoutContext = once(() => 
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createContext(undefined));
